import profilePic from '../../assests/images/profile_pic_nk.png'
import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Download, BookOpen, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isGlitching, setIsGlitching] = useState(false);

  useEffect(() => {
    const glitchInterval = setInterval(() => {
      setIsGlitching(true);
      setTimeout(() => setIsGlitching(false), 200);
    }, 3000);

    return () => clearInterval(glitchInterval);
  }, []);

  const buttonVariants = {
    hover: {
      scale: 1.05,
      textShadow: "0 0 8px rgb(0, 255, 255)",
      boxShadow: "0 0 8px rgb(0, 255, 255)",
      transition: {
        duration: 0.3,
        yoyo: Infinity
      }
    }
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <motion.header 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className="py-12"
    >
      <div className="flex flex-col md:flex-row items-center justify-between gap-8">
        {/* Left side - Profile Image */}
        <motion.div 
          className="profile-pic relative order-2 md:order-1"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 300 }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-cyan-400 to-[#ff00ff] opacity-20 blur-lg" />
          <img 
            src={profilePic}
            alt="Profile" 
            className="w-48 h-48 md:w-64 md:h-64 object-cover border-2 border-cyan-400 rounded-lg relative z-10"
          />
        </motion.div>

        {/* Right side - Text and Buttons */}
        <div className="text-center md:text-left order-1 md:order-2 flex-1">
          <div className="mb-8">
            <h1 className={`text-4xl md:text-6xl font-orbitron mb-2 ${isGlitching ? 'glitch' : ''}`}>  
              Nagaraj<span className="animate-pulse">_</span>K
            </h1>
            <motion.p 
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.2 }}
              className="text-base md:text-xl text-cyan-400"
            >
              Software Development | Cloud | Database
            </motion.p>
          </div>

          {/* Quick Action Buttons */}
          <div className="flex flex-wrap justify-center md:justify-start gap-2 md:gap-4">
            {/* Resume Button - Opens in new tab */}
            <motion.a
              href="https://drive.google.com/file/d/1Hk50AQApAMvGtP33NDixWPYxHc1fSDYu/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              variants={buttonVariants}
              whileHover="hover"
              className="flex items-center gap-1 md:gap-2 px-4 md:px-6 py-2 md:py-3 bg-black border-2 border-cyan-400 rounded-lg text-sm md:text-base text-cyan-400 hover:border-[#ff00ff] hover:text-[#ff00ff] transition-colors"
            >
              <Download size={20} />
              <span>Resume</span>
            </motion.a>

            {/* Blogs Button - Uses React Router */}
            <motion.div variants={buttonVariants} whileHover="hover">
              <Link
                to="/blogs"
                className="flex items-center gap-1 md:gap-2 px-4 md:px-6 py-2 md:py-3 bg-black border-2 border-cyan-400 rounded-lg text-sm md:text-base text-cyan-400 hover:border-[#ff00ff] hover:text-[#ff00ff] transition-colors"
              >
                <BookOpen size={20} />
                <span>My Blogs</span>
              </Link>
            </motion.div>

            {/* Contact Button - Smooth scroll */}
            <motion.button
              onClick={scrollToContact}
              variants={buttonVariants}
              whileHover="hover"
              className="flex items-center gap-1 md:gap-2 px-4 md:px-6 py-2 md:py-3 bg-black border-2 border-cyan-400 rounded-lg text-sm md:text-base text-cyan-400 hover:border-[#ff00ff] hover:text-[#ff00ff] transition-colors"
            >
              <Mail size={20} />
              <span>Contact</span>
            </motion.button>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;
